import { CarouselItem } from '@/types/pdp'
import { ProductDetailsPageHelper } from '@/scripts/libs/pdp'

class AlgoliaPdp implements ProductDetailsPageHelper {
  fetchCarousel = async (): Promise<null | Array<CarouselItem>> => {
    const stringifiedAlgoliaAnalytics = localStorage.getItem('algoliaTracking')

    const algoliaAnalytics = stringifiedAlgoliaAnalytics
      ? JSON.parse(stringifiedAlgoliaAnalytics)
      : ''
    return algoliaAnalytics?.algolia?.carouselOrder ?? []
  }

  fetchPDPDataFromService = async () => {
    throw new Error('Method not implemented.')
  }

  fetchProductDescription = async () => {
    throw new Error('Method not implemented.')
  }

  getPDPDataFromPage = () => {
    throw new Error('Method not implemented.')
  }

  fetchAvailabilityData = async () => {
    throw new Error('Method not implemented.')
  }

  fetchLensDetails = async () => {
    throw new Error('Method not implemented.')
  }
}

export default new AlgoliaPdp()
